/**
 * Configuración centralizada de la aplicación
 * Este archivo permite acceder a todas las variables de entorno y configuraciones importantes
 * de una manera más ordenada y con validaciones básicas.
 */

// URLs y endpoints
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://taheqwabfahvzniabmhh.supabase.co';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
export const RESEND_API_KEY = import.meta.env.VITE_RESEND_API_KEY || '';
export const FROM_EMAIL = import.meta.env.VITE_FROM_EMAIL || 'reference@disolgua.com';

// URL del proxy de Cloudflare para imágenes
export const CLOUDFLARE_PROXY_URL = import.meta.env.VITE_CLOUDFLARE_PROXY_URL || '';



// URL base de Supabase Storage
export const SUPABASE_STORAGE_BASE_URL = `${SUPABASE_URL}/storage/v1/object/public/`;

// Mensajes de error comunes
export const ERROR_MESSAGES = {
  MISSING_PROXY_URL: 'La URL del proxy de Cloudflare no está configurada, usando URL por defecto.',
  PROXY_ERROR: 'Error al cargar la imagen desde el proxy.',
  NETWORK_ERROR: 'Error de red. Comprueba tu conexión a Internet.',
};

// Configuración de imágenes
export const IMAGE_CONFIG = {
  DEFAULT_PLACEHOLDER: 'https://via.placeholder.com/300?text=Imagen+no+disponible',
  LAZY_LOADING: true,
  FORMATS: ['webp', 'jpg', 'png', 'jpeg', 'gif'],
};

// Función de validación básica de la configuración
export function validateConfig(): { valid: boolean; issues: string[] } {
  const issues: string[] = [];
  
  if (!SUPABASE_URL) {
    issues.push('VITE_SUPABASE_URL no está configurada');
  }
  
  if (!SUPABASE_ANON_KEY) {
    issues.push('VITE_SUPABASE_ANON_KEY no está configurada');
  }
  
  // Ya no es crítico tener CLOUDFLARE_PROXY_URL configurada
  // porque usamos una URL por defecto en imageProxy.ts
  

  
  return {
    valid: issues.length === 0,
    issues
  };
}

// Validar la configuración en desarrollo
if (import.meta.env.DEV) {
  const validation = validateConfig();
  if (!validation.valid) {
    console.warn('⚠️ Problemas con la configuración:', validation.issues);
  } else {
    console.log('✅ Configuración validada correctamente');
  }
}

export default {
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  CLOUDFLARE_PROXY_URL,
  SUPABASE_STORAGE_BASE_URL,
  IMAGE_CONFIG,
  validateConfig
}; 